import { combineReducers } from 'redux'

import orderService from './order/orderService'
import * as orderSelectors from './order/orderService.selectors'

import * as helpers from './orderService.helpers'

export const orderServiceHelpers = {
  ...helpers,
}

export const orderServiceSelectors = {
  ...orderSelectors,
}

export const orderServiceReducers = combineReducers({
  order: orderService,
})
